import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, HomeIcon } from '@heroicons/react/24/outline';

const Breadcrumb = ({ items, className = '' }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav aria-label="מסלול ניווט" className={`${className}`}>
      <ol className="flex items-center flex-wrap gap-1 sm:gap-2 text-xs sm:text-sm" role="list">
        {/* Home Link */}
        <li>
          <Link
            to="/"
            className="flex items-center text-gray-500 hover:text-primary-600 transition-colors"
            aria-label="חזרה לדף הבית"
          >
            <HomeIcon className="h-4 w-4" aria-hidden="true" />
            <span className="sr-only">בית</span>
          </Link>
        </li>

        {/* Breadcrumb Items */}
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={index} className="flex items-center" role="listitem">
              <ChevronLeftIcon className="h-3 w-3 sm:h-4 sm:w-4 text-gray-400 mx-1" aria-hidden="true" />
              
              {isLast ? (
                <span 
                  className="font-medium text-gray-900 truncate max-w-[120px] sm:max-w-none"
                  aria-current="page"
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-gray-500 hover:text-primary-600 transition-colors truncate max-w-[100px] sm:max-w-none"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;

